import React from 'react';
import NxtbnModal from '../../components/Modal';
import { SectionSchema } from './schemaService';

interface SectionSchemaChooserModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSelect: (sectionRefs: string) => void;
    sectionsSchema: SectionSchema[];
}

function SectionSchemaChooserModal({ 
    isOpen, 
    onClose, 
    onSelect,
    sectionsSchema
}: SectionSchemaChooserModalProps) {
    return (
        <NxtbnModal 
            isOpen={isOpen} 
            onClose={onClose}
            size="lg"
        >
            <div className="flex flex-col">
                {/* Header */}
                <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
                    <div className="flex items-center space-x-3">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                        <h2 className="text-xl font-semibold text-gray-800">
                            Select a Section Type
                        </h2>
                    </div>
                    <button 
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-green-500 rounded-full p-2 transition-colors"
                        aria-label="Close modal"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {/* Content */}
                <div className="px-6 py-8">
                    <p className="text-gray-600 text-sm mb-6 text-center">
                        Choose a section type that best fits your content structure.
                    </p>
                    
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                        {sectionsSchema.map((schema) => (
                            <div 
                                key={schema.sectionRefs}
                                onClick={() => {
                                    onSelect(schema.sectionRefs);
                                    onClose();
                                }}
                                className="group cursor-pointer border border-gray-200 rounded-lg p-4 text-center 
                                           hover:border-green-300 hover:bg-green-50 
                                           transition-all duration-300 
                                           transform hover:-translate-y-1 hover:shadow-md"
                            >
                                <div className="mb-3 flex justify-center">
                                    <span className="bg-green-100 text-green-700 text-xs font-medium px-2.5 py-0.5 rounded">
                                        {schema.label}
                                    </span>
                                </div>
                                
                                <h3 className="font-semibold text-gray-800 group-hover:text-green-700 transition-colors">
                                    {schema.sectionRefs}
                                </h3>
                                
                                <div className="mt-2 opacity-0 group-hover:opacity-100 transition-opacity">
                                    <p className="text-xs text-gray-500">
                                        Click to add this section type
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </NxtbnModal>
    );
}

export default SectionSchemaChooserModal;